import { useTranslations } from 'next-intl';
import { Button } from '@mentimeter/ragnar-ui/button';

export const CommentsViewSwitcher = ({
  showResolvedComments,
  resolvedCommentsCount,
  onSwitchView,
}: {
  showResolvedComments: boolean;
  onSwitchView: () => void;
  resolvedCommentsCount: number;
}) => {
  const t = useTranslations('creation.comments');

  if (showResolvedComments) {
    return (
      <Button
        variant="primary"
        my="space2"
        onClick={onSwitchView}
        style={{ alignSelf: 'center' }}
      >
        {resolvedCommentsCount > 0
          ? t('comments_switch_hide_resolved_comments_button')
          : t('comments_switch_go_back_to_comments_button')}
      </Button>
    );
  }

  if (resolvedCommentsCount > 0) {
    return (
      <Button
        variant="subtle"
        my="space2"
        onClick={onSwitchView}
        style={{ alignSelf: 'center' }}
      >
        {t('comments_switch_show_resolved_comments_button', {
          count: resolvedCommentsCount,
        })}
      </Button>
    );
  }

  return null;
};
